import { useCallback } from "react";
import { useBackgroundServiceManager } from "../services/background-service-manager";
import type { BackgroundServiceRegistration } from "../types";

export function useBackgroundService() {
  const registerService = useBackgroundServiceManager((s) => s.register);
  const unregisterService = useBackgroundServiceManager((s) => s.unregister);
  const getService = useBackgroundServiceManager((s) => s.getService);
  const getAllServices = useBackgroundServiceManager((s) => s.getAllServices);

  const register = useCallback(
    async (registration: BackgroundServiceRegistration) => {
      await registerService(registration);
    },
    [registerService]
  );

  const unregister = useCallback(
    async (serviceId: string) => {
      await unregisterService(serviceId);
    },
    [unregisterService]
  );

  return { register, unregister, getService, getAllServices };
}
